var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传图片",
            visible: _vm.visible,
            width: "950px",
            modal: _vm.booleanVal,
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("el-button", {
            staticClass: "selfDialogClose",
            attrs: {
              type: "text",
              icon: "el-icon-close",
              circle: "",
              size: "medium",
            },
            on: { click: _vm.handleClose },
          }),
          _vm.visible
            ? _c("upload-picture", {
                attrs: {
                  isMore: _vm.isMore,
                  modelName: _vm.modelName,
                  isShowVideo: _vm.isShowVideo,
                  defaultType: _vm.defaultType,
                },
                on: { getImage: _vm.getImage },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }